import { render, staticRenderFns } from "./AePopover.vue?vue&type=template&id=46e4a826&scoped=true"
import script from "./AePopover.vue?vue&type=script&lang=js"
export * from "./AePopover.vue?vue&type=script&lang=js"
import style0 from "./AePopover.vue?vue&type=style&index=0&id=46e4a826&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e4a826",
  null
  
)

export default component.exports